import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    q: "How fast do I receive my CV?",
    a: "Instantly. Our AI analyzes and rewrites your CV in minutes — you watch it happen right after checkout.",
  },
  {
    q: "Is the resume ATS-friendly?",
    a: "Yes. Every CV is structured to pass through Applicant Tracking Systems with proper headings, clean formatting, and keyword-rich content tailored to your industry.",
  },
  {
    q: "Can I use my existing CV?",
    a: "Absolutely. Upload your current resume and our AI will rewrite, restructure, and visually upgrade it. You can also share your information through a quick form.",
  },
  {
    q: "What format will I receive?",
    a: "You receive a polished, recruiter-ready PDF optimized for both human readers and ATS software. Editable formats can be provided on request.",
  },
  {
    q: "Is this suitable for all industries?",
    a: "Yes. From software engineering and design to finance, healthcare, and executive roles — every CV is customized to your field, role, and seniority.",
  },
  {
    q: "How is this different from a DIY resume builder?",
    a: "DIY tools make you do the work. We handle everything: upload your CV and get a finished, professionally rewritten and redesigned ATS-ready PDF in minutes.",
  },
  {
    q: "Do I need to write anything myself?",
    a: "No. Send us your existing resume or fill a simple form, and our AI engine rewrites, restructures and designs it for maximum impact.",
  },
  {
    q: "What industries do you cover?",
    a: "All of them. From entry-level to executive, our AI is trained on what recruiters scan for across tech, marketing, finance, healthcare, engineering and more.",
  },
  {
    q: "Can you tailor my resume to a specific job?",
    a: "Yes — every plan is optimized for the keywords and ATS systems relevant to your target roles, and our Elite plan includes end-to-end career rebrand.",
  },
  {
    q: "Is my data private?",
    a: "Yes. Your resume and personal information are only used to craft your document and are never shared or sold.",
  },
  {
    q: "How do I send you my CV?",
    a: "After you order, reply to our confirmation email or WhatsApp us with your current CV and the role you are targeting, and we take it from there.",
  },
  {
    q: "How long does delivery take?",
    a: "Delivered in minutes — our AI works instantly after checkout.",
  },
  {
    q: "What does ATS-ready mean?",
    a: "ATS is software used by 99% of Fortune 500 companies to filter resumes before a human sees them; we optimize your resume to pass those filters.",
  },
  {
    q: "What if I want changes?",
    a: "Free revision within 7 days of delivery.",
  },
  {
    q: "Is my CV and personal data safe?",
    a: "Used only to produce your resume and deleted from our systems after delivery.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      className="relative py-24 sm:py-32"
      data-testid="faq-section"
    >
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.18em] text-zinc-500">
            FAQ
          </p>
          <h2
            className="mt-3 text-3xl md:text-4xl font-semibold tracking-tight text-white text-balance"
            data-testid="faq-headline"
          >
            Frequently asked questions
          </h2>
          <p className="mt-4 text-zinc-400">
            Everything you need to know before getting your AI-crafted resume.
          </p>
        </div>

        <div className="mt-12">
          <Accordion type="single" collapsible className="w-full space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="rounded-2xl border border-white/10 bg-zinc-950/50 px-5 data-[state=open]:border-white/20 transition-colors"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="text-left text-sm sm:text-base text-white hover:no-underline"
                  data-testid={`faq-trigger-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  className="text-sm text-zinc-400 leading-relaxed"
                  data-testid={`faq-content-${i}`}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
